module.exports = __webpack_public_path__ + "img/beer_id-109.2343e04c.png";